import { get, formatUrl, post } from '../../../utils/request'
import {
  TALENT_ALERT_SETTINGS,
  TALENT_LIST_URL,
  LIST_CITY,
  LIST_NEIGHBORHOOD,
  LIST_TALENT_DETAIL,
  LIST_TALENT_ALERT,
  TALENT_QUALIFICATION_LIST_URL,
  JOB_CATEGORY_LIST_URL
} from '../../../utils/urls'

const actions = {
  fetchTalents: async (context, payload) => {
    try {
      let response = await get(TALENT_LIST_URL, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setTalents', response.data['results'])
        context.commit('setTotalTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setTalents', [])
    }
  },
  fetchTalentsCategory: async (context, payload) => {
    try {
      let response = await get(JOB_CATEGORY_LIST_URL, payload)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentsCategory', response.data['results'])
      }
    } catch (e) {
      context.commit('setTalentsCategory', [])
    }
  },
  fetchTalentsQualification: async (context) => {
    try {
      let response = await get(TALENT_QUALIFICATION_LIST_URL)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentsCategory', response.data['results'])
      }
    } catch (e) {
      context.commit('setTalentsCategory', [])
    }
  },
  fetchTalentListCity: async (context, payload) => {
    try {
      let response = await get(LIST_CITY)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentListCity', response.data['results'])
      }
    } catch (e) {
      context.commit('setTalentListCity', [])
    }
  },
  getTalentListNeighborhood: async (context, payload) => {
    try {
      let url = formatUrl(LIST_NEIGHBORHOOD, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentListNeighborhood', response.data['results'])
      }
    } catch (e) {
      context.commit('setTalentListNeighborhood', [])
    }
  },
  getTalentProfileVideo: async (context, payload) => {
    try {
      let url = formatUrl(LIST_TALENT_DETAIL, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentProfileVideo', response.data)
      }
    } catch (e) {
      context.commit('setTalentProfileVideo', [])
    }
  },
  fetchTalentsAlert: async (context, payload) => {
    try {
      let response = await get(LIST_TALENT_ALERT, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentsAlert', response.data['results'])
        context.commit('setTotalAlertTalents', response.data['count'])
      }
    } catch (e) {
      context.commit('setTalentsAlert', [])
      context.commit('setTotalAlertTalents', 0)
    }
  },
  fetchTalentAlertSettings: async (context) => {
    try {
      let response = await get(TALENT_ALERT_SETTINGS)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentAlertSettings', response.data['results'])
      }
    } catch (e) {
      context.commit('setTalentAlertSettings', [])
    }
  },
  postTalentAlertSettings: async (context, payload) => {
    await post(TALENT_ALERT_SETTINGS, payload.params)
  }
}

export default actions
